import { observer } from 'mobx-react';
import CheckoutPaymentTypes from '../../components/CheckoutPaymentTypes/CheckoutPaymentTypes';
import CheckoutPromocode from '../../components/CheckoutPromocode/CheckoutPromocode';
import CheckoutResendSMS from '../../components/CheckoutResendSMS/CheckoutResendSMS';
import CheckoutWallet from '../../components/CheckoutWallet/CheckoutWallet';
import OrderCartTotalInfo from '../../components/OrderCartTotalInfo/OrderCartTotalInfo';
import { useCheckoutStoreContext } from '../../context';
import Text, { TEXT } from 'src/view/components/Text/Text';
import CheckoutCashbackError from '~/view/screens/CheckoutScreen/components/CheckoutCashbackError/CheckoutCashbackError';

const SummaryDetails: React.FC = observer((): JSX.Element => {
  const { store: checkoutStore } = useCheckoutStoreContext();

  return (
    <div className="d-flex flex-column gap-20">
      {/* title */}
      <Text type={TEXT.SECTION_HEADER} text="txt_checkout" />
      {/* payment types picker */}
      <CheckoutPaymentTypes />
      {/* resend sms switcher */}
      <CheckoutResendSMS />
      {checkoutStore.isDraft ? (
        <>
          {/* wallet block */}
          <CheckoutWallet />
          <CheckoutCashbackError />
          {/* promocode block */}
          <CheckoutPromocode />
        </>
      ) : null}
      {/* total info block */}
      <OrderCartTotalInfo />
    </div>
  );
});

export default SummaryDetails;
